<div class="nav-header" [ngClass]="{'collapsed': (collapsed$ | async)}">
  @if (isMobile$ | async) {
    <button
      type="button"
      class="close-button icon-btn ficon-app-x"
      [attr.aria-label]="'dashboard_collapse-sidebar' | translate"
      (click)="toggleSideNav.emit()">
    </button>
  }
  @if (isLTI) {
    <logo></logo>
  } @else {
    <waffle-button
      #waffleButton
      class="unified-login-button"
      [attr.api-base]="unifiedLoginApiBase"
      current-product="EchoReflect"
      [attr.current-role]="unifiedCurrentRole"
      [hidden]="!waffleVisible">
    </waffle-button>
    @if ((collapsed$ | async) === false || !waffleVisible) {
      @if ((collapsed$ | async) === false) {
        <img
          class="navigation-logo"
          [class.no-waffle]="!waffleVisible"
          [alt]="unifiedFullLogo.alt"
          [src]="unifiedFullLogo.src">
      } @else {
        <img
          class="navigation-logo navigation-logo-spot"
          [alt]="unifiedSpotLogo.alt"
          [src]="unifiedSpotLogo.src">
      }
    }
  }
</div>
<div class="nav-body" [ngClass]="{'student-nav': isPresenter}">
  <ul class="nav-tree" [ngClass]="{'collapsed': (collapsed$ | async)}">
    @for (org of orgs | alphabeticalByKey:'name'; track org) {
      @let currentRoute = transitionState$ | async;
      @let isCollapsed = collapsed$ | async;
      <li class="org-item" [ngClass]="{ 'has-invite-btn': canInvite(org) && isCollapsed === false }">
        <a
          class="org nav-link"
          [attr.href]="getOrgHref(org)"
          [ngClass]="{'selected': isOrgSelected(org, currentRoute) && isCollapsed === false}"
          (click)="onOrgLinkClick($event, org)"
          data-cy="org-link"
          matTooltipPosition="below"
          [matTooltip]="org.name"
		  [attr.aria-current]="isOrgSelected(org, currentRoute) ? 'page' : null">
          @if (isCollapsed === false) {
            <span>{{org.name}}</span>
          }
          @if (isCollapsed === true) {
            <div class="initials" [ngClass]="{'active': isOrgSelected(org, currentRoute) && isCollapsed === true}">{{ org.name | abbreviateOrgName  }}</div>
          }
        </a>
        @if (canInvite(org) && isCollapsed === false) {
          <button
            class="invite-btn icon-btn ficon-add-user"
            [ngClass]="{'selected': isOrgSelected(org, currentRoute)}"
            data-cy="invite-org"
            type="button"
            [attr.aria-label]="'course-menu_invite-org-users' | translate"
            (click)="openInviteModal($event, org)">
          </button>
        }
      </li>
    }
  </ul>
  <ul class="nav-content" [ngClass]="{'collapsed': (collapsed$ | async)}">
    <li>
      <a
        class="archive nav-link"
        [attr.href]="getArchiveHref()"
        [ngClass]="{'selected': (transitionState$ | async) === states.DASHBOARD_ARCHIVE}"
        data-cy="archive-link"
        (click)="onArchiveLinkClick($event)"
        [matTooltip]="'common_archive' | translate"
        [matTooltipDisabled]="(collapsed$ | async) === false"
        >
        <i class="ficon-archive"></i>
        @if ((collapsed$ | async) === false) {
          <span translate>common_archive</span>
        }
      </a>
    </li>
    @if (shouldShowFeaturedMessage$ | async) {
      <li>
        <featured-message></featured-message>
      </li>
    }
  </ul>
</div>
<ul class="nav-bottom" [ngClass]="{'collapsed': (collapsed$ | async)}">
  @if (shouldShowFeatureFlags()) {
    <li>
      <a
        class="feature-flags nav-link"
        tabindex="0"
        [matTooltip]="'feature-flags' | translate"
        [matTooltipDisabled]="(collapsed$ | async) === false"
        (click)="openFeatureFlags()"
        (keyup.enter)="openFeatureFlags()"
        (keyup.space)="openFeatureFlags()">
        <i class="ficon-flag-o"></i>
        @if ((collapsed$ | async) === false) {
          <span translate>feature-flags</span>
        }
      </a>
    </li>
  }
  @if (shouldShowHeyGen()) {
    <li>
      <a
        class="heygen nav-link"
        tabindex="0"
        [matTooltip]="'heygen-editor' | translate"
        [matTooltipDisabled]="(collapsed$ | async) === false"
        (click)="openHeyGen()"
        (keyup.enter)="openHeyGen()"
        (keyup.space)="openHeyGen()">
        <i class="ficon-puzzle-piece"></i>
        @if ((collapsed$ | async) === false) {
          <span translate>heygen-editor</span>
        }
      </a>
    </li>
  }
  @if (shouldShowLicenseManagement()) {
    <li>
      <a
        class="license nav-link"
        [attr.href]="getLicenseHref()"
        [ngClass]="{'selected': licenseStates.includes(transitionState$ | async)}"
        [attr.aria-label]="'license-management' | translate"
        [matTooltip]="'license-management' | translate"
        [matTooltipDisabled]="(collapsed$ | async) === false"
        (click)="onLicenseLinkClick($event)">
        <i class="ficon-edit-list"></i>
        @if ((collapsed$ | async) === false) {
          <span translate>license-management</span>
        }
      </a>
    </li>
  }
  @if (shouldShowLibraryButton()) {
    <li>
      <a
        class="library nav-link"
        tabindex="0"
        role="button"
        data-cy="library-button"
        [attr.aria-label]="'common_library' | translate"
        [matTooltip]="'common_library' | translate"
        [matTooltipDisabled]="(collapsed$ | async) === false"
        (click)="openLibrary()"
        (keydown.enter)="openLibrary()"
        (keyup.space)="openLibrary()">
        <i class="ficon-app-library"></i>
        @if ((collapsed$ | async) === false) {
          <span translate>common_library</span>
        }
      </a>
    </li>
  }
  @if (!isLTI) {
    <li>
      <a
        target="_blank"
        href="https://support.echo360.com/hc/en-us/categories/37644637471373-GoReact"
        class="help nav-link"
        tabindex="0"
        [matTooltip]="'help_feedback' | translate"
        [matTooltipDisabled]="(collapsed$ | async) === false"
        analytics-on="click"
        analytics-category="Help"
        analytics-event="Help!"
        (keyup.space)="openHelp()"
        [attr.aria-label]="'help_feedback' | translate"
        >
        <i class="ficon-app-help-circle-outline"></i>
        @if ((collapsed$ | async) === false) {
          <span translate>help_feedback</span>
        }
      </a>
    </li>
  }
  @if (shouldShowCustomParams()) {
    <li>
      <a
        class="custom-params nav-link"
        tabindex="0"
        [matTooltip]="'custom-params' | translate"
        [matTooltipDisabled]="(collapsed$ | async) === false"
        [attr.aria-label]="'custom-params' | translate"
        (click)="openCustomParamsModal()"
        (keyup.enter)="openCustomParamsModal()"
        (keyup.space)="openCustomParamsModal()">
        <i class="ficon-app-help-circle-outline"></i>
        @if ((collapsed$ | async) === false) {
          <span translate>custom-params</span>
        }
      </a>
    </li>
  }
  @if (!(isLTI && whiteLabel)) {
    <li>
      <a
        class="give-feedback nav-link"
        tabindex="0"
        role="button"
        [matTooltip]="'customer-feedback-navigation-label' | translate"
        [matTooltipDisabled]="(collapsed$ | async) === false"
        (click)="openFeedbackSnackbar()"
        (keyup.enter)="openFeedbackSnackbar()"
        (keyup.space)="openFeedbackSnackbar()"
        [attr.aria-label]="'customer-feedback-navigation-label' | translate"
        analytics-on="click"
        analytics-category="Feedback"
        analytics-event="Give feedback!"
        aria-haspopup="dialog"
        >
        <i class="ficon-pointy-star"></i>
        @if ((collapsed$ | async) === false) {
          <span class="give-feedback-label" translate>customer-feedback-navigation-label</span>
        }
      </a>
    </li>
  }
</ul>
